<div class="container-fluid bg-gold-gradient py-5 position-relative overflow-hidden dp-hero">

  <div class="container ">
    <div class="row align-items-start">

      <!-- LEFT -->
      <div class="col-lg-6 text-dark">
        <img src="assets/img/d-and-p-2.png" class="img-fluid w-25 mb-5" alt="Deals & Pobs" />
        <!-- Heading -->
        <h1 class="display-4 fw-bold lh-sm mb-4">
          Welcome to D&P<br />
          Welcome to all the<br />
          savings.
        </h1>
        <!-- Stores -->
        <h4 class="fw-semibold mb-3 mt-5 ">Our most popular stores</h4>

        <div class="d-flex gap-3 flex-wrap mt-3">
          <div
            class="store-icon d-flex align-items-center justify-content-center fs-5 bg-white rounded-4 shadow-sm fw-bold fs-1">
            a</div>
          <div
            class="store-icon d-flex align-items-center justify-content-center fs-5 bg-white rounded-4 shadow-sm text-danger fw-bold fs-1">
            ♥</div>
          <div
            class="store-icon d-flex align-items-center justify-content-center fs-5 bg-white rounded-4 shadow-sm text-success fw-bold fs-1">
            ●</div>
          <div
            class="store-icon d-flex align-items-center justify-content-center fs-5 bg-white rounded-4 shadow-sm text-warning fw-bold fs-1">
            ♥</div>
          <div
            class="store-icon d-flex align-items-center justify-content-center fs-5 bg-white rounded-4 shadow-sm text-danger fw-bold fs-1">
            w</div>
        </div>

      </div>
      <!-- RIGHT -->
      <div class="col-12 col-lg-6">

        <h4 class="fw-semibold mb-3 text-start text-lg-start  mt-3 mt-lg-0">Today's top deals</h4>
        <!-- Deal Card -->
        @if (placementsData['Homepage']?.length) {
        @for (item of placementsData['Homepage']; track item) {
        <a [routerLink]="['/view', item.id]" target="_blank" rel="noopener" class="deal-home-card bg-white rounded-4 d-flex align-items-center shadow-sm
             mb-3 text-decoration-none text-dark hover-transform transition-all p-2">
          <!-- Image -->
          <img [src]="item.imageUrl" class="deal-img object-fit-cover rounded-3 flex-shrink-0" alt="Deal Image" />

          <!-- Title -->
          <div class="flex-grow-1 ms-3 overflow-hidden">
            <h6 class="fw-bold mb-0 ">{{ item.title }}</h6>
          </div>

          <!-- Arrow -->
          <i class="fa-solid fa-angle-right mx-3 text-muted"></i>
        </a>
        }
        }
      </div>
    </div>
  </div>
  <!-- Bottom Curve -->
  <div class="hero-curve bg-white d-none d-lg-block"></div>
</div>
<!-- <section>2</section> -->
<div class="container-fluid bg-light">
  <div class="container py-5">
    <h2 class="text-center fw-bold mb-5">Hot Deals</h2>
    @if (placementsData['Deals Section']?.length) {
    <div class="row g-4 justify-content-center">
      @for (item of placementsData['Deals Section']; track item) {
      <div class="col-12 col-md-6 col-lg-4">
        <a [routerLink]="['/view', item.id]" target="_blank" rel="noopener"
          class="card h-100 border-0 shadow-sm rounded-4 text-decoration-none text-dark hover-translate transition-all">
          <div class="card-body p-3">
            <div class="row g-0 align-items-center h-100">
              <!-- IMAGE COLUMN -->
              <div class="col-4">
                <div class="rounded-3 overflow-hidden bg-white shadow-sm border" style="height: 100px;">
                  <img [src]="item.imageUrl" class="img-fluid w-100 h-100 object-fit-cover" alt="" />
                </div>
              </div>
              <!-- CONTENT COLUMN -->
              <div class="col-8 ps-3">
                <div class="fw-bold text-uppercase text-primary small mb-1">
                  {{ item.category || 'Deal' }}
                </div>
                <p class="mb-0 fw-medium lh-sm">
                  {{ item.title }}
                </p>
              </div>
            </div>
          </div>
        </a>
      </div>
      }
    </div>
    }
  </div>
</div>
<!-- <section>3</section> -->
<div class="container py-5">
  <div class="row g-4">
    <!-- LEFT DEAL LIST -->
    @if (placementsData['Sidebar']?.length) {
    <div class="col-12 col-lg-8 ">
      <h4 class="fw-bold mb-4">Trending Now</h4>
      <!-- Deal Item -->
      @for (item of placementsData['Sidebar']; track item) {
      <a [routerLink]="['/view', item.id]" target="_blank" rel="noopener" class="d-flex align-items-center shadow-sm mb-4 rounded-4 border deal-card
            text-decoration-none text-dark">

        <!-- Image -->
        <img [src]="item.imageUrl" class="deal-no3-img rounded-3 flex-shrink-0" alt="" />

        <!-- Title -->
        <div class="flex-grow-1 ms-3">
          <h5 class="fw-bold mb-1">{{ item.title }}</h5>
          <span class="text-muted small">Limited time offer</span>
        </div>

        <!-- Arrow -->
        <i class="fa-solid fa-angle-right me-3"></i>

      </a>
      }
    </div>
    }

    <!-- RIGHT PROMO CARD -->
    @if (placementsData['Homepage']?.length) {
    <div class="col-12 col-lg-4">
      <h4 class="fw-bold mb-4">Featured</h4>
      <div id="carouselExampleCaptions" class="carousel slide shadow rounded-4 overflow-hidden" data-bs-ride="carousel">
        <div class="carousel-inner section-height">
          @for (item of placementsData['Homepage']; track item; let i = $index) {
          <div class="carousel-item h-100" [class.active]="i === 0">

            <!-- CLICKABLE SLIDE -->
            <a [routerLink]="['/view', item.id]" target="_blank" rel="noopener"
              class="d-block w-100 h-100 text-decoration-none position-relative">
              <img [src]="item.imageUrl" class="d-block w-100 h-100 object-fit-cover" alt="{{ item.title }}" />
              <div class="position-absolute bottom-0 start-0 w-100 p-4"
                style="background: linear-gradient(to top, rgba(0,0,0,0.8), transparent);">
                <h5 class="text-white fw-bold mb-1 text-truncate">{{ item.title }}</h5>
                <small class="text-white-50">Don't miss out!</small>
              </div>
            </a>
          </div>
          }
        </div>
        <!-- Controls -->
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions"
          data-bs-slide="prev">
          <span class="carousel-control-prev-icon"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions"
          data-bs-slide="next">
          <span class="carousel-control-next-icon"></span>
        </button>
      </div>
    </div>
    }
  </div>
</div>

<div class="container-fluid py-5 bg-white border-top">
  <div class="container">
    <h2 class="text-center fw-bold mb-4">
      Deals By Category
    </h2>

    <div #categoryScroll class="
          category-scroll
          d-flex px-2 pb-3
          gap-3 gap-md-4 gap-lg-5
          overflow-auto
          justify-content-start justify-content-lg-center
          
        ">
      @for (cat of uniqueCategories; track cat) {
      <div class="text-center flex-shrink-0" style="width:120px; cursor: pointer;" [routerLink]="['/category', cat]">

        <div class="rounded-circle bg-light border border-2 border-warning
                     d-flex align-items-center justify-content-center
                     mx-auto mb-3 shadow-sm hover-scale transition-all mt-3" style="width:100px;height:100px">
          <img src="https://via.placeholder.com/120" class="img-fluid w-50" alt="" />
        </div>

        <span class="small fw-bold text-dark d-block text-uppercase">
          {{ cat }}
        </span>

      </div>
      }
    </div>
  </div>
</div>